import React from "react";
import Paper from "../components/ui-library/Paper/Paper";
import { UAParser } from "ua-parser-js";
import { connect } from "react-redux";
import { mapStateToPropsFooter } from "../modules/layout";
import { useTranslation } from "react-i18next";

const DebugHeader = () => {
  const { t } = useTranslation();

  return (
    <div>
      <h3>{t("appText.debug.debugInfo")}</h3>
    </div>
  );
};

const Debug = (props) => {
  const { backendVersion } = props;

  const { t } = useTranslation();

  return (
    <div
      id="content"
      className="container-fluid debug-info-container"
      style={{ minHeight: "auto" }}
    >
      <div className="row">
        <Paper header={<DebugHeader />} fullWidth>
          <div className="item">
            <label className="bold-label capitalize-label">
              {t("appText.debug.environment")}:{" "}
            </label>
            {process.env.REACT_APP_BRANCH}
          </div>
          <div className="item">
            <label className="bold-label capitalize-label">
              {t("appText.debug.frontendVersion")}:{" "}
            </label>
            {process.env.REACT_APP_VERSION}
          </div>
          <div className="item">
            <label className="bold-label capitalize-label">
              {t("appText.debug.backendVersion")}:{" "}
            </label>
            {backendVersion}
          </div>
          <div>{getUa(t)}</div>
        </Paper>
      </div>
    </div>
  );
};

const getUa = (t) => {
  const ua = new UAParser().getResult();
  return Object.keys(ua).map((item, index) => {
    return (
      <div className="item" key={`item_${index}`}>
        {ua[item][0] ? (
          <label className="bold-label capitalize-label">
            {t(`appText.debug.${item}`)}:{" "}
          </label>
        ) : (
          <h5>{t(`appText.debug.${item}`)}</h5>
        )}
        {typeof ua[item] === "object"
          ? Object.keys(ua[item]).map((subitem, subindex) => {
              return (
                <div className="mr-1 item" key={`subitem_${subindex}`}>
                  <label className="bold-label capitalize-label">
                    {t(`appText.debug.${subitem}`)}
                  </label>
                  : {ua[item][subitem] || "unknown"}
                </div>
              );
            })
          : `${ua[item] || "unknown"}`}
      </div>
    );
  });
};

const mapStateToProps = (state) => ({
  ...mapStateToPropsFooter(state),
});

export default connect(mapStateToProps, null)(Debug);
